<template>
  <div id="approverComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
   <v-container>
      <v-layout class="mb-2" row wrap>
        <v-spacer></v-spacer>
        <v-text-field v-model="approverSearch" :label="$t('general.search')" clearable append-outer-icon="search"> </v-text-field>
        <v-dialog persistent v-model="dialog" max-width="700px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" round outline v-on="on">
              <v-icon left>person</v-icon>
              {{ $t('approver.add') }}
            </v-btn>
          </template>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ formTitle }}
              </h2>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-xs>
                  <v-form lazy-validation ref="form" v-model="valid">
                    <v-autocomplete
                      v-model="selectedApprover.user_id"
                      :items="filterUsers"
                      item-text="name"
                      item-value="id"
                      :label="$t('approver.selectUser')"
                      :rules="rules.required"
                      :error-messages="errors.user_id">
                    </v-autocomplete>
                    <v-switch
                      v-model="selectedApprover.is_default"
                      :label="$t('general.default')"
                    ></v-switch>
                  </v-form>
                </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="save">
                {{ $t('general.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog persistent v-model="dialog_update" max-width="700px">
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black primary--text mb-0">
                {{ $t('approver.default') }}
              </h2>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-xs>
                  <span class="subheading">
                    {{ $t('approver.default_message') }}
                  </span>
                </v-container>
              </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary darken-1" round flat @click="close">
                {{ $t('general.cancel') }}
              </v-btn>
              <v-btn
                :loading="loading"
                :disabled="loading"
                color="primary"
                round
                depressed
                @click="save">
                {{ $t('general.save') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_delete" max-width="500px" persistent>
          <v-card>
            <v-toolbar flat>
              <h2 class="font-weight-black error--text mb-0">
                {{ $t('approver.delete') }}
              </h2>
            </v-toolbar>
            <v-card-text>
              <span class="subheading" v-html="$t('approver.deleteUserQuestion', {name : nameUserDelete})"> </span>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" round flat @click="dialog_delete=false">
              {{ $t('general.cancel') }}
                </v-btn>
              <v-btn color="error" round depressed @click="confirmRemove(removedApprover)">
              {{ $t('general.delete') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
      <v-data-table
        :search="approverSearch"
        class="elevation-2"
        :headers="headers"
        :items="filterApprovers"
        :loading="loadingItems"
        :rows-per-page-items="[10, 15, 25]"
        :pagination.sync="pagination">
        <template v-slot:headers="props">
          <tr class="bg-heavy-rain">
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="[
                'font-weight-black white--text column',
                header.sortable ? 'sortable' : '',
                pagination.descending ? 'desc' : 'asc',
                header.value === pagination.sortBy ? 'active' : '',
              ]"
              @click="changeSort(header.value)"
            >
              <h2 class="font-weight-black primary--text mb-0">
                <v-icon small class="primary--text" v-if="header.sortable">arrow_upward</v-icon>
                {{ header.text }}
              </h2>
            </th>
          </tr>
        </template>
        <template v-slot:items="props">
          <tr>
            <td width="60px">{{ props.item.id }}</td>
            <td class="text-sm-center">{{ props.item.users[0].name }}</td>
            <td class="text-sm-center">
              <v-icon v-if="props.item.is_default" color="success" left>check_circle</v-icon>
            </td>
            <td width="200px" class="text-sm-center">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn small outline icon color="info" v-on="on" :disabled="props.item.is_default === 1" @click="editApprover(props.item)">
                    <v-icon small>check_circle</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('approver.default') }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn small outline icon color="error" v-on="on" :disabled="props.item.is_default === 1" @click="deleteApprover(props.item)">
                    <v-icon small>delete</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t('general.delete') }}</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'approverComponent',
  data () {
    return {
      approverSearch: '',
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 15,
        totalItems: 0
      },
      disabled: true,
      dialog_update: false,
      dialog_delete: false,
      dialog: false,
      valid: true,
      editedIndex: -1,
      users: [],
      userLogged: {
        roles: [
          {
            id: null
          }
        ],
        company: [
          {
            id: null
          }
        ]
      },
      selectedApprover: {
        user_id: 0,
        is_default: false
      },
      defaultApprover: {
        user_id: 0,
        is_default: false
      },
      removedApprover: {},
      approvers: [],
      loading: false,
      loadingItems: true,
      saveDisabled: false,
      error: false,
      errors: {},
      errorMessage: '',
      nameUserDelete: ''
    }
  },
  computed: {
    heading () {
      return this.$t('general.approver')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-user-check fa-fw icon-color'
    },
    formTitle () {
      return this.editedIndex === -1
        ? this.$t('approver.add')
        : this.$t('approver.edit')
    },
    approverDuplicated () {
      return this.$t('approver.duplicate')
    },
    rules () {
      return this.$validationRules()
    },
    filterApprovers () {
      return this.approvers.filter(
        (item) => item.users[0].company[0].id === this.userLogged.company[0].id)
    },
    filterUsers () {
      return this.users.filter(item => item.company.length !== 0 && item.company[0].id === this.userLogged.company[0].id && item.active === 1)
    },
    headers () {
      return [
        {
          text: '#',
          align: 'center',
          value: 'id',
          sortable: true
        },
        {
          text: this.$t('general.name'),
          align: 'center',
          value: 'users[0].name',
          sortable: true
        },
        {
          text: this.$t('general.default'),
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          sortable: false
        }
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    filterApproversOLD () {
      if (this.filterApproversOLD.length >= 1) {
        this.disabled = true
      } else if (this.filterApproversOLD.length < 1) {
        this.disabled = false
      }
    },
    '$store.state.userLogged' () {
      this.getLogged()
    }
  },
  created () {
    this.getLogged()
    this.get()
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
      }
    },
    close () {
      this.dialog = false
      this.dialog_update = false
      this.errors = {}
      this.selectedApprover = Object.assign({}, this.defaultApprover)
      this.editedIndex = -1
      this.$refs.form.resetValidation()
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.put()
        } else {
          this.post()
        }
      }
    },
    confirmRemove (item) {
      const index = this.approvers.indexOf(item)
      this.delete(item, index)
      this.dialog_delete = false
    },
    editApprover (item) {
      this.editedIndex = this.approvers.indexOf(item)
      this.selectedApprover = Object.assign({}, item)
      this.dialog_update = true
    },
    deleteApprover (item) {
      this.removedApprover = item
      this.nameUserDelete = item.users[0].name
      this.dialog_delete = true
    },
    get () {
      this.$emit('get', {
        context: this
      })
    },
    post () {
      this.$emit('saveApprover', {
        item: this.selectedApprover,
        context: this
      })
    },
    put () {
      this.selectedApprover.is_default = 1
      this.$emit('put', {
        item: this.selectedApprover,
        index: this.editedIndex,
        context: this
      })
    },
    delete (item, index) {
      this.$emit('removeApprover', {
        item: item,
        index: index,
        context: this
      })
    },
    refresh () {
      this.$emit('refresh', { context: this })
    },
    changeSort (header) {
      if (this.pagination.sortBy === header) {
        this.pagination.descending = !this.pagination.descending
      } else {
        this.pagination.descending = false
      }
      this.pagination.sortBy = header
    }
  }
}
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/approver.component.vue